
import HotelBookingMain from "../../components/hotel-booking-report/HotelBookingMain"

export const HotelBookingReport = ({ title_1, title_2, title }) => {
   
    return <div>
        <HotelBookingMain title_1={title_1} title_2={title_2} title={title} />
    </div>
}